export default __webpack_public_path__ + "static/bottom-391c5e097da97f1dcd12fb0efa18d782.png";